/* =============================================
   FILE: assets/wallet.js
   Shopify Wallet — Option 2 (Liquid + Metafields)
   ============================================= */

function walletCopyCode() {
  var codeEl = document.getElementById('wallet-code-value');
  var copyText = document.getElementById('wallet-copy-text');

  if (!codeEl) return;

  var code = codeEl.textContent.trim();

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(function () {
      walletShowCopied(copyText);
    }).catch(function () {
      walletFallbackCopy(code, copyText);
    });
  } else {
    walletFallbackCopy(code, copyText);
  }
}

function walletFallbackCopy(text, copyTextEl) {
  var ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
    walletShowCopied(copyTextEl);
  } catch (e) {}
  document.body.removeChild(ta);
}

function walletShowCopied(el) {
  if (!el) return;
  var original = el.textContent;
  el.textContent = 'Copied!';
  setTimeout(function () {
    el.textContent = original;
  }, 2000);
}
